var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.401,
    height: 14.142,
    viewBox: "0 0 6.401 14.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Expand_icon",
    "data-name": "Expand icon",
    transform: "translate(-6.911 7.071) rotate(-45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2759",
    "data-name": "Group 2759",
    transform: "translate(2.15 2.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M17.657,6.179a.522.522,0,0,1-.522-.522V3.193H14.672a.522.522,0,0,1,0-1.043h2.986a.522.522,0,0,1,.522.522V5.657A.522.522,0,0,1,17.657,6.179Z",
    transform: "translate(-8.179 -2.15)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M5.657,18.179H2.672a.522.522,0,0,1-.522-.522V14.672a.522.522,0,0,1,1.043,0v2.464H5.657a.522.522,0,1,1,0,1.043Z",
    transform: "translate(-2.15 -8.179)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M13.672,6.676a.522.522,0,0,1-.369-.891L16.786,2.3a.522.522,0,0,1,.738.738L14.041,6.524A.52.52,0,0,1,13.672,6.676Z",
    transform: "translate(-7.676 -2.15)",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M2.672,17.676a.522.522,0,0,1-.369-.891L5.786,13.3a.522.522,0,1,1,.738.738L3.041,17.524A.52.52,0,0,1,2.672,17.676Z",
    transform: "translate(-2.15 -7.676)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandicon);
export default __webpack_public_path__ + "static/media/Expand icon.436ebbe4329f94c15c40be2cad10e197.svg";
export { ForwardRef as ReactComponent };